import React from 'react';
import { createUserModel } from 'models/user';
import ManageUser from 'components/ManageUser';

export default function AdminCreateUser() {
    const newUser = createUserModel();

    return (
        <div data-testid="route-users-create">
            <ManageUser user={newUser} action={'create'} />
        </div>
    );
}
